<script>
	import { Icon, Text } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';

	export let noResultsFound = {
		icon: 'fa-light fa-camera-cctv',
		title: $format('recordings_list_no_recordings', {
			default: 'No events recorded yet',
		}),
		description: $format('recordings_list_no_recordings_description', {
			default: 'Recordings will appear here when event is detected.',
		}),
	};
</script>

<div class="flex-full-height align-items-center">
	<Icon class="mb-m" size="l" icon={noResultsFound?.icon} />
	<Text styleType="body-small" class="mb-s text-bold text-center">
		{noResultsFound?.title}
	</Text>
	<Text class="text-color-muted text-center" styleType="body-extra-small">
		{noResultsFound?.description}
	</Text>
</div>
